@for (doc of fileList; track doc; let i = $index) {
<div
  class="document-container"
  [ngClass]="{ 'document-container-top': i == 0 }"
>
  <span style="font-weight: 500; font-size: 14px"
    >{{ i + 1 + ". " }}{{ doc.name | translate }}</span
  >
  <app-document
    [patientIdInput]="patientIdInput"
    [document]="getDocument(doc.id)"
    [fileTypeId]="doc.id.toString()"
    [isEditMode]="isEditMode"
  ></app-document>
</div>
@if (i != fileList.length - 1) {
<div
  style="border-bottom: 1px solid gray; height: 5px; width: 100%; margin: 5px"
></div>
} }
